import React, { Component } from 'react';
import CollectionBrowser from "./../../components/collectionBrowser";
import LookBookQuoteContainer from "./../../components/lookBookQuoteContainer";
import CollectionBanner from "./../../components/collectionBanner";
import LookBookCenteredImage from "./../../components/lookBookCenteredImage";
import LookBookFullWidthImage from "./../../components/lookBookFullWidthImage";
import LookBookOnePhotoAndColor from "./../../components/lookBookOnePhotoAndColor";
import LookBookSideBySideImages from "./../../components/lookBookSideBySideImages";
import ScrollFadeIn from "./../../components/scrollFadeIn";
import PublicSpeakingTeaser from "./../../components/publicSpeakingTeaser";
import BannerFadeIn from "./../../components/bannerFadeIn";
import Flodeskform from "./../../components/flodeskForm";
import BackButton from './../../alpineComponents/backButton';
import Footer from './../../components/footer';
import {Helmet} from "react-helmet";

export default class About extends Component {
  render() {
    return (
      <div>
        <Helmet>
          <title>{'Kat Medina | Author of the book, The Joys of Jet Lag'}</title>
          <meta name="description" content="World traveler. Writer. Entrepreneur. Joy finder. Kat Medina, author of The Joys of Jet Lag." />
        </Helmet>
        <BannerFadeIn>
          <CollectionBanner
            mobileOptimize={true}
            image={'/images/about-hero.jpg'}
            subtitle={'Author. Adventurer. Joy Finder.'}
            title={'Meet Kat Medina'}
          />
        </BannerFadeIn>
        <div className="section-padding">
          <div className="max-width-container">
            <div className="row">
              <div className="small-12 medium-6" style={{backgroundImage:'url(/images/about-headshot.jpg)', backgroundSize:'cover', backgroundPosition:'center'}}>
              </div>
              <div className="small-12 medium-6 small-padding primary-background white">
                <p className="tiny-padding">{`Entrepreneur, world traveler, and public speaker, Kat Medina is the author of `}<i>{`The Joys of Jet Lag: How to Use a Traveler’s Mindset to Not Be An A-Hole in Daily Life`}</i>{`. She’s traveled to more than 40 countries, and lived in Ecuador, Argentina, France, and Spain. Kat draws upon her passion for travel to inspire joy in others, teaching people how to show up and live fully by embodying a traveler’s mindset in daily life. `}</p>
                <p className="tiny-padding">{`Since becoming a parent, she’s written her debut children’s book, `}<i>{`Grumple the Great`}</i>{`, a surprisingly silly tale of kindness based in beautiful Lake Tahoe.`}</p>
                <p className="tiny-padding">{`Kat lives in South Lake Tahoe, California with her husband, two sons, and giant Golden Retriever named Donut. She loves adventuring outdoors, traveling the world, and seeking out moments of awe and joy every day.`}</p>
                <div className="tiny-padding">
                  <a download href="/zip/katmedina.zip">
                    <div className="button white-background primary-color">{'Download Media Kit'}</div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="section-padding" style={{paddingTop:0}}>
          <div className="text-max-width-container">
            <p className="tiny-padding">{'As a child, I wanted to be MacGyver when I grew up. Now, as an author and public speaker, I’ve become a well-traveled bookworm who teaches people how to discover more joy in daily life with the resourcefulness of a figurative shoelace, paperclip, and bubblegum. Not quite the MacGyver I had in mind, but at least this way I don’t have to rock a mullet (although I, unfortunately, did so as a kid).'}</p>

            <p className="tiny-padding">{'I graduated Cum Laude from California State University, Monterey Bay with a degree in international business and founded Alpine Design LLC, a digital creative agency based in South Lake Tahoe, CA with my husband. My unique work-to-travel lifestyle has led me to be featured in Maynard Webb and Carlye Adler’s NYT bestseller, Rebooting Work. The career that I created has given me the freedom to pursue my passion and travel to more than 40 countries, as well as, live in Ecuador, Argentina, France, Spain, and currently, my native United States.'}</p>

            <p className="tiny-padding">{'For much of my life, I had noticed a clear difference between the person I was during my travels and who I was at home. During my time abroad, I easily embodied my values for living a passionate and purposeful life. And yet, when I returned from trips, I would revert back to futile attempts to control external factors, feeling frustrated if things didn’t go as planned, and often overlooking the gifts around me due to their commonality and predictability. Several years ago, I made it my mission to bridge the gap between who I am when I travel and who I am at home.'}</p>

            <p className="tiny-padding">{'My book, The Joys of Jet Lag, explores the most valuable lessons I’ve learned during the process and shares the keys to creating a life of adventure through an openhearted approach to living. These insights, when embodied and applied, have the potential to transform the ordinary to the extraordinary and craft unbridled joy and fulfillment, no matter where you are.'}</p>
          </div>
        </div>
        <ScrollFadeIn>
          <LookBookSideBySideImages
            images={[
              {
                  image:"/images/tall-rectangle.png",
                  backgroundImage:'/images/about-headshot.jpg',
                  latlng:[38.291962,-122.458000],
                  city:"Sonoma, California"
              },{
                  image:"/images/tall-rectangle.png",
                  backgroundImage:'/images/about-franz.jpg',
                  latlng:[-43.387299,170.182007],
                  city:"Franz Josef, New Zealand"
              },{
                  image:"/images/tall-rectangle.png",
                  backgroundImage:'/images/about-donut.jpg',
                  latlng:[38.941631,-119.977219],
                  city:"South Lake Tahoe, California"
              }
            ]}
          />
        </ScrollFadeIn>
        <ScrollFadeIn>
          <PublicSpeakingTeaser />
        </ScrollFadeIn>
        <ScrollFadeIn>
          <LookBookFullWidthImage
            image='/images/about-guatever.jpg'
            latlng={[14.556830,-90.733620]}
            city="Antigua, Guatemala"
          />
        </ScrollFadeIn>
        <ScrollFadeIn>
          <Flodeskform />
        </ScrollFadeIn>
        <Footer />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/about/index.js